import { render, staticRenderFns } from "./FooterItemDesktop.vue?vue&type=template&id=3cd2f189&"
import script from "./FooterItemDesktop.vue?vue&type=script&lang=js&"
export * from "./FooterItemDesktop.vue?vue&type=script&lang=js&"
import style0 from "./FooterItemDesktop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports